module.exports = __webpack_public_path__ + "static/img/thumbnail_pdf.3a903899.svg";